import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Empty,
    Flex,
    Skeleton,
    Input,
    Spin,
    Tag,
    Space,
    Tooltip,
    Typography,
    Dropdown,
    message,
    Menu,
} from "antd";
import {
    SearchOutlined,
    PlusOutlined,
    ReloadOutlined,
    EditOutlined,
    DeleteOutlined,
    DownOutlined,
    LeftOutlined,
    RightOutlined,
    InboxOutlined,
} from "@ant-design/icons";
import CreateNews from "./CreateNews";
import { useNavigate } from "react-router-dom";
import api from "../../../api";
import RejectionModal from "../Approval/RejectionModal";


const { Title, Text } = Typography;

const News = () => {
    const [openCreateNews, setOpenCreateNews] = useState(false);
    const [newsData, setNewsData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [newsTypeFilter, setNewsTypeFilter] = useState("All");
    const [statusFilter, setStatusFilter] = useState("All");
    const [expandedId, setExpandedId] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [selectedNews, setSelectedNews] = useState(null);


    const [pageSize, setPageSize] = useState(6);
    const [editData, setEditData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();


    // 🔥 Dummy Data (replace with API later)
    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            setLoading(true);

            const payload = {
                synceddatetime: "2025-05-29 10:08:00",
                FormCode: "102",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                AppTypeNo: "3",
            };

            const res = await api.getnews(payload);

            if (res?.data?.status === "1") {
                const sortedData = [...(res.data.services_products_data || [])].sort(
                    (a, b) =>
                        new Date(b.fld_news_created_date) -
                        new Date(a.fld_news_created_date)
                );

                setNewsData(sortedData);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };



    const handleDelete = async () => {
        if (!selectedNews) return;

        try {
            setLoading(true);

            const payload = {
                fld_rf_id: selectedNews.fld_rf_id,
                synceddatetime: "2025-05-29 10:08:00",
                FormCode: "102",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                AppTypeNo: "3",
            };

            const res = await api.deleteNews(payload);

            if (res?.data?.status === "1") {
                fetchNews();
                messageApi.success("Charity deleted successfully");

            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setOpenDeleteModal(false);
            setSelectedNews(null);
        }
    };
    // 🔍 Filters
    const filteredData = newsData.filter((item) => {
        const title = item?.fld_news_title || "";
        const type = item?.fld_news_type_name || "";
        const status = item?.fld_news_active_id === "1" ? "Active" : "Inactive";

        const matchesSearch = title
            .toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchesType =
            newsTypeFilter === "All" || type === newsTypeFilter;

        const matchesStatus =
            statusFilter === "All" || status === statusFilter;

        return matchesSearch && matchesType && matchesStatus;
    });


    // 📄 Pagination
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = filteredData.slice(
        startIndex,
        startIndex + pageSize
    );
    const totalPages = Math.ceil(filteredData.length / pageSize);

    const pageMenu = (
        <Menu
            items={[6, 10, 20].map((num) => ({
                key: num,
                label: num,
                onClick: () => {
                    setPageSize(num);
                    setCurrentPage(1);
                },
            }))}
        />
    );


    const NewsSkeleton = () => (
        <Card className="review-card">
            <Flex justify="space-between" align="center">

                <Flex gap={16}>
                    <Skeleton.Image
                        active
                        style={{
                            width: 80,
                            height: 80,
                        }}
                    />

                    <div>
                        {/* Title + Status */}
                        <div
                            style={{
                                display: "flex",
                                gap: 8,
                                marginBottom: 8,
                            }}
                        >
                            <Skeleton.Input
                                active
                                size="small"
                                style={{
                                    width: 220,
                                    height: 16,
                                }}
                            />

                            <Skeleton.Button
                                active
                                size="small"
                                style={{
                                    width: 70,
                                }}
                            />
                        </div>

                        {/* Description */}
                        <Skeleton
                            active
                            title={false}
                            paragraph={{
                                rows: 2,
                                width: ["90%", "70%"],
                            }}
                        />

                        {/* Type + Date */}
                        <div
                            style={{
                                display: "flex",
                                gap: 12,
                                marginTop: 8,
                            }}
                        >
                            <Skeleton.Button
                                active
                                size="small"
                                style={{ width: 90 }}
                            />

                            <Skeleton.Input
                                active
                                size="small"
                                style={{ width: 140 }}
                            />
                        </div>
                    </div>
                </Flex>

                <Space>
                    <Skeleton.Button active size="small" />
                    <Skeleton.Button active size="small" />
                </Space>

            </Flex>
        </Card>
    );

    return (
        <>
            {/* Create Modal */}
            {contextHolder}
            <CreateNews
                visible={openCreateNews}
                handleCancel={() => {
                    setOpenCreateNews(false);
                    setEditData(null); // reset
                }}
                editdata={editData}
                onSuccess={() => {
                    setOpenCreateNews(false);
                    setEditData(null);
                    fetchNews(); // refresh after create/edit
                }}
            />

            {openDeleteModal && (
                <RejectionModal
                    title="Delete News"
                    content="Are you sure you want to delete this news? This action cannot be undone."
                    buttonName="Delete"
                    open={openDeleteModal}
                    onClose={() => {
                        setOpenDeleteModal(false);
                        setSelectedNews(null);
                    }}
                    onSubmit={handleDelete}
                />
            )}

            <div className="review-page">

                {/* 🔥 Header */}
                <Flex className="review-header" justify="space-between" align="center" style={{ marginBottom: 16 }}>
                    <Input
                        className="review-search"
                        prefix={<SearchOutlined />}
                        placeholder="Search news..."
                        style={{ width: 300 }}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />

                    <Space>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setOpenCreateNews(true)}
                            style={{ background: "#0072b1" }}
                        >
                            Create News
                        </Button>
                    </Space>
                </Flex>

                {/* 🔥 Title */}
                <div className="review-container">
                    <div className="review-heading">
                        <Title level={4} style={{ margin: 0 }}>News Management</Title>
                        <Text type="secondary">
                            Manage, publish, and edit your news articles
                        </Text>
                    </div>

                    {/* 🔥 Filters */}
                    <div className="review-filters">
                        <div className="filter-buttons">
                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[
                                            { key: "All", label: "All", onClick: () => setNewsTypeFilter("All") },
                                            { key: "KOPA News", label: "KOPA News", onClick: () => setNewsTypeFilter("KOPA News") },
                                            { key: "Global News", label: "Global News", onClick: () => setNewsTypeFilter("Global News") },
                                        ]}
                                    />
                                }
                            >
                                <Button>
                                    {newsTypeFilter} <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[
                                            { key: "All", label: "All", onClick: () => setStatusFilter("All") },
                                            { key: "Active", label: "Active", onClick: () => setStatusFilter("Active") },
                                            { key: "Inactive", label: "Inactive", onClick: () => setStatusFilter("Inactive") },
                                        ]}
                                    />
                                }
                            >
                                <Button>
                                    Status <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Button
                                icon={<ReloadOutlined />}
                                onClick={() => {
                                    setNewsTypeFilter("All");
                                    setSearchTerm("");
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>

                    {/* 🔥 Cards */}
                    <div style={{ display: "grid", gap: 16 }}>
                        {loading ? (
                            Array.from({ length: 6 }).map((_, index) => (
                                <NewsSkeleton key={index} />
                            ))
                        ) : paginatedData.length === 0 ? (
                            <Card>
                                <Empty
                                    description="No news available"
                                    image={<InboxOutlined style={{ fontSize: 40 }} />}
                                />
                            </Card>
                        ) : (
                            paginatedData.map((news) => (
                                <Card
                                    key={news.fld_rf_id}
                                    hoverable
                                    className="review-card"


                                    onClick={() =>
                                        navigate(`news/${news.fld_rf_id}`, {
                                            state: {
                                                newsData: {
                                                    id: news.fld_news_id,
                                                    title: news.fld_news_title,
                                                    rf_id: news.fld_rf_id,
                                                    news_sw_id: news.fld_news_sw_id,
                                                    subdescription: news.fld_news_sub_description,
                                                    description: news.fld_news_description,
                                                    type: news.fld_news_type_name || "General",
                                                    image: news.fld_image_path || "https://via.placeholder.com/300",
                                                    link: news.fld_hyper_link,
                                                    createdDate: news.fld_news_created_date,
                                                    endDate: news.fld_form_end_time,
                                                    status: news.fld_is_active === "1" ? "Published" : "Inactive",
                                                },
                                            },
                                        })
                                    }


                                >
                                    <Flex justify="space-between" align="center">

                                        {/* Left */}
                                        <Flex gap={16}>
                                            <img
                                                src={news.fld_image_path || "https://via.placeholder.com/80"}
                                                alt="news"
                                                style={{
                                                    width: 80,
                                                    height: 80,
                                                    objectFit: "cover",
                                                    borderRadius: 8,
                                                }}
                                            />

                                            <div>
                                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    <Text strong>{news.fld_news_title || "Untitled"}</Text>

                                                    {/* ✅ Status */}
                                                    <Tag color={news.fld_news_active_id === "1" ? "green" : "red"}>
                                                        {news.fld_news_active_id === "1" ? "Active" : "Inactive"}
                                                    </Tag>
                                                </div>

                                                {/* Description */}
                                                <div style={{ color: "#888", maxWidth: 400 }}>
                                                    <div
                                                        style={
                                                            expandedId === news.fld_rf_id
                                                                ? {}
                                                                : {
                                                                    display: "-webkit-box",
                                                                    WebkitLineClamp: 2,
                                                                    WebkitBoxOrient: "vertical",
                                                                    overflow: "hidden",
                                                                }
                                                        }
                                                    >
                                                        {news.fld_news_description || "No description"}
                                                    </div>

                                                    {news.fld_news_description?.length > 80 && (
                                                        <span
                                                            style={{
                                                                color: "#1677ff",
                                                                cursor: "pointer",
                                                                fontSize: 12,
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setExpandedId(
                                                                    expandedId === news.fld_rf_id
                                                                        ? null
                                                                        : news.fld_rf_id
                                                                );
                                                            }}
                                                        >
                                                            {expandedId === news.fld_rf_id
                                                                ? "Show less"
                                                                : "Show more..."}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Type + Date */}
                                                <Flex gap={15}>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Tag color="default">
                                                            {news.fld_news_type_name || "General"}
                                                        </Tag>
                                                    </div>

                                                    <div style={{ marginTop: 4 }}>
                                                        <Text type="secondary">
                                                            Published:{" "}
                                                            {news.fld_news_created_date || "N/A"}
                                                        </Text>
                                                    </div>
                                                    <div style={{ marginTop: 4 }}>
                                                        <Text type="secondary">
                                                            End date:{" "}
                                                            {news.fld_form_end_time || "N/A"}
                                                        </Text>
                                                    </div>
                                                </Flex>
                                            </div>
                                        </Flex>

                                        {/* Right */}
                                        <Space>
                                            <Tooltip title="Edit this News">
                                                <Button
                                                    icon={<EditOutlined />}
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();

                                                        const mappedData = {
                                                            ...news,

                                                            // ✅ map API → form fields
                                                            fld_news_type: news.fld_news_type_name,
                                                            fld_news_image: news.fld_image_path,
                                                            fld_publish_date: news.fld_news_created_date,
                                                            fld_status: news.fld_is_active === "1" ? "Active" : "Inactive",
                                                            fld_news_link: news.fld_hyper_link,
                                                        };

                                                        setEditData(mappedData);
                                                        setOpenCreateNews(true);
                                                    }}
                                                >
                                                    Edit
                                                </Button>
                                            </Tooltip>

                                            <Tooltip title="Delete this News">
                                                <Button
                                                    icon={<DeleteOutlined />}
                                                    size="small"
                                                    danger
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedNews(news);
                                                        setOpenDeleteModal(true);
                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            </Tooltip>
                                        </Space>
                                    </Flex>
                                </Card>
                            ))
                        )}
                    </div>

                    {/* 🔥 Pagination */}
                    <Flex justify="center" align="center" gap={10} style={{ marginTop: 20 }}>
                        <Button
                            icon={<LeftOutlined />}
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                        />

                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>

                        <Button
                            icon={<RightOutlined />}
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                        />

                        <Dropdown overlay={pageMenu}>
                            <Button>
                                {pageSize} / page <DownOutlined />
                            </Button>
                        </Dropdown>
                    </Flex>
                </div>
            </div>

        </>
    );
};

export default News;